import * as yup from 'yup';

export const useRefereeDetailsStepFormSchema = () => {
  const schema = yup.object({
    referee1: yup.object({
      refereeTitle: yup.string().required('Title is a required field'),
      refereeSurname: yup.string().required('Surname is a required field'),
      refereeForenames: yup.string().required('Forenames is a required field'),

      refereePreviousNames: yup.string(),
      refereeBirthDate: yup.string().required('Birth Date is a required field'),
      refereeBirthPlace: yup.string(),
      refereeHomeAddress: yup.string().required('Home Address is a required field'),
      refereeHomePostcode: yup.string(),
      refereeHomeMobileNumber: yup.string(),
      refereeHomeEmail: yup.string(),

      refereeEmployment: yup.string(),
      refereeOccupation: yup.string().required('Occupation is a required field'),
      refereeWorkMobileNumber: yup.string(),
      refereeWorkEmail: yup.string(),
      refereeCapacity: yup.string().required('This field is required'),
      refereeKnown: yup.string().required('This field is required'),
    }),
    referee2: yup.object({
      refereeTitle: yup.string().required('Title is a required field'),
      refereeSurname: yup.string().required('Surname is a required field'),
      refereeForenames: yup.string().required('Forenames is a required field'),

      refereePreviousNames: yup.string(),
      refereeBirthDate: yup.string().required('Birth Date is a required field'),
      refereeBirthPlace: yup.string(),
      refereeHomeAddress: yup.string().required('Home Address is a required field'),
      refereeHomePostcode: yup.string(),
      refereeHomeMobileNumber: yup.string(),
      refereeHomeEmail: yup.string(),

      refereeEmployment: yup.string(),
      refereeOccupation: yup.string().required('Occupation is a required field'),
      refereeWorkMobileNumber: yup.string(),
      refereeWorkEmail: yup.string(),
      refereeCapacity: yup.string().required('This field is required'),
      refereeKnown: yup.string().required('This field is required'),
    }),
  });

  return { schema };
};
